// Static content and imagery for TA CLÉ INVEST landing page.

export const PROJECTS = [
  {
    id: "aegean-villas",
    category: "residential",
    location: { tr: "Güney Ege, Türkiye", en: "South Aegean, Türkiye", ar: "جنوب بحر إيجه، تركيا", ru: "Южный Эгей, Турция" },
    title: { tr: "Anahtar Ege Villaları", en: "Anahtar · Aegean Villas", ar: "فلل أناختار على بحر إيجه", ru: "Виллы Anahtar · Эгей" },
    lede: {
      tr: "Sınırlı sayıda üretilen, mimari detay ve manzarayla imzalanmış özel villa hattı.",
      en: "A limited edition of private villas — signed by architectural detail and by the sea.",
      ar: "خط محدود من الفلل الخاصة، موقَّع بالتفاصيل المعمارية والإطلالة على البحر.",
      ru: "Ограниченный тираж частных вилл, отмеченных архитектурной деталью и видом на море.",
    },
    image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=1400&q=85",
    year: "2024 —",
  },
  {
    id: "sisli-commercial",
    category: "commercial",
    location: { tr: "Merkezi İş Koridoru, İstanbul", en: "Central Business Corridor, Istanbul", ar: "المحور التجاري المركزي، إسطنبول", ru: "Центральный деловой коридор, Стамбул" },
    title: { tr: "Prime Ofis Kiralama Portföyü", en: "Prime Office Rental Suites", ar: "محفظة إيجارات المكاتب الراقية", ru: "Портфель премиальных офисных аренд" },
    lede: {
      tr: "İstanbul'un merkezi iş koridorundaki üst düzey iş kulelerinde tam kat ofisler — kurumsal kiracılara anahtar teslim, uzun vadeli kiralanan lüks çalışma alanları.",
      en: "Full-floor office suites inside upper-tier towers on Istanbul's central business corridor — turnkey luxury workspaces, long-leased to institutional and international tenants.",
      ar: "طوابق مكتبية كاملة داخل أبراج راقية على المحور التجاري المركزي في إسطنبول — مساحات عمل فاخرة جاهزة، مؤجَّرة طويل الأجل لمستأجرين مؤسسيين ودوليين.",
      ru: "Полноэтажные офисные апартаменты в премиальных башнях центрального делового коридора Стамбула — премиальные рабочие пространства «под ключ», сдаваемые в долгосрочную аренду.",
    },
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=85",
    year: "2022 —",
  },
  {
    id: "anatolia-industrial-land",
    category: "land",
    location: { tr: "Marmara & Ege Koridoru", en: "Marmara & Aegean Corridor", ar: "ممر مرمرة وإيجه", ru: "Мраморный и Эгейский коридор" },
    title: { tr: "Anadolu Endüstriyel Toprak Bankası", en: "Anatolia Industrial Land Bank", ar: "بنك الأراضي الصناعية الأناضولية", ru: "Промышленный земельный банк Анатолии" },
    lede: {
      tr: "Türkiye'nin büyüme koridorlarında sabırlı el altında tutulan endüstriyel ve karma parseller.",
      en: "Industrial and mixed-zone parcels held in patient hands across Türkiye's growth corridors.",
      ar: "قِطع صناعية ومختلطة تُحتفظ بأيدٍ صبورة في ممرات النمو التركية.",
      ru: "Промышленные и смешанные участки, удерживаемые терпеливыми руками в коридорах роста Турции.",
    },
    image: "https://images.unsplash.com/photo-1470723710355-95304d8aece4?auto=format&fit=crop&w=1400&q=85",
    year: "2021 —",
  },
  {
    id: "bosphorus-residences",
    category: "residential",
    location: { tr: "Boğaz Hattı, İstanbul", en: "Bosphorus Line, Istanbul", ar: "خط البوسفور، إسطنبول", ru: "Линия Босфора, Стамбул" },
    title: { tr: "Boğaz Kira Portföyü", en: "Bosphorus Lease Portfolio", ar: "محفظة إيجار البوسفور", ru: "Арендный портфель Босфора" },
    lede: {
      tr: "Boğaz görüşlü, sınırlı sayıda üst gelir konut varlığı — kira portföyünde tutuluyor.",
      en: "A limited set of Bosphorus-view upper-tier residences, held inside a rental portfolio.",
      ar: "مجموعة محدودة من العقارات السكنية الفاخرة بإطلالة على البوسفور، ضمن محفظة إيجارية.",
      ru: "Ограниченный набор элитных резиденций с видом на Босфор, удерживаемых в арендном портфеле.",
    },
    image: "https://images.pexels.com/photos/16798575/pexels-photo-16798575.jpeg?auto=compress&cs=tinysrgb&w=1400",
    year: "2023",
  },
  {
    id: "mixed-use-anatolia",
    category: "mixed",
    location: { tr: "Kocaeli, Türkiye", en: "Kocaeli, Türkiye", ar: "كوجه إيلي، تركيا", ru: "Коджаэли, Турция" },
    title: { tr: "Anadolu Karma Kullanım Bloğu", en: "Anatolia Mixed-use Block", ar: "مجمع أناضولي متعدد الاستخدامات", ru: "Многофункциональный квартал в Анатолии" },
    lede: {
      tr: "Perakende, konut ve ofisi tek bir mimari çerçevede birleştiren yerleşke.",
      en: "A single architectural frame binding retail, residential and office in one address.",
      ar: "إطار معماري واحد يجمع التجزئة والسكن والمكاتب في عنوان واحد.",
      ru: "Единая архитектурная рама, объединяющая ретейл, жильё и офис по одному адресу.",
    },
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=85",
    year: "2024",
  },
  {
    id: "logistics-hub",
    category: "commercial",
    location: { tr: "Gebze, Türkiye", en: "Gebze, Türkiye", ar: "غيبزه، تركيا", ru: "Гебзе, Турция" },
    title: { tr: "Marmara Lojistik Merkezi", en: "Marmara Logistics Hub", ar: "مركز مرمرة اللوجستي", ru: "Логистический хаб Мрамора" },
    lede: {
      tr: "Marmara koridorunda kurumsal kiracılara uzun vadeli kiralanan endüstriyel varlık.",
      en: "An industrial asset long-leased to institutional tenants along the Marmara corridor.",
      ar: "أصل صناعي مؤجَّر طويل الأجل لمستأجرين مؤسسيين على ممر مرمرة.",
      ru: "Промышленный актив с долгосрочной арендой институциональным арендаторам на Мраморном коридоре.",
    },
    image: "https://images.pexels.com/photos/2804929/pexels-photo-2804929.jpeg?auto=compress&cs=tinysrgb&w=1400",
    year: "2022",
  },
];

export const TEAM = [
  {
    id: "chairman",
    name: "T. A. Clé",
    role: { tr: "Yönetim Kurulu Başkanı", en: "Chair of the Board", ar: "رئيس مجلس الإدارة", ru: "Председатель совета" },
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=800&q=85",
  },
  {
    id: "md",
    name: "Genel Müdür",
    role: { tr: "Genel Müdür", en: "Managing Director", ar: "المدير العام", ru: "Управляющий директор" },
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=85",
  },
  {
    id: "cio",
    name: "Yatırım Direktörü",
    role: { tr: "Yatırım Direktörü", en: "Head of Investments", ar: "مدير الاستثمار", ru: "Директор по инвестициям" },
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=800&q=85",
  },
  {
    id: "cfo",
    name: "Mali İşler Direktörü",
    role: { tr: "Mali İşler Direktörü", en: "Chief Financial Officer", ar: "المدير المالي", ru: "Финансовый директор" },
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=85",
  },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    quote: {
      tr: "TA Clé Invest, gayrimenkulü elektronik tablo değil, saha çalışması olarak görüyor. Bu ekiple ortak olmak, işi anlayan biriyle aynı masaya oturmak demek.",
      en: "TA Clé Invest treats real estate as fieldwork, not a spreadsheet. Partnering with this team means sitting at the same table as someone who actually understands the work.",
      ar: "يتعامل TA Clé Invest مع العقار كعمل ميداني لا كجدول بيانات. الشراكة مع هذا الفريق تعني الجلوس إلى الطاولة نفسها مع من يفهم العمل حقاً.",
      ru: "TA Clé Invest относится к недвижимости как к полевой работе, а не таблице. Партнёрство с этой командой — это стол с тем, кто действительно понимает дело.",
    },
    author: "H. Baumann",
    role: { tr: "Ortak, İsviçre Aile Ofisi", en: "Partner, Swiss Family Office", ar: "شريك، مكتب عائلي سويسري", ru: "Партнёр, швейцарский семейный офис" },
  },
  {
    id: "t2",
    quote: {
      tr: "Türkiye'de uzun vadeli düşünen, arazi konumlandırmasını sabırla kuran bir ortak bulmak nadir. Bu ekip tam olarak öyle.",
      en: "Long-term thinking on Türkiye is rare — and a partner who builds land positioning with patience, rarer still. That is exactly this team.",
      ar: "التفكير طويل الأمد في تركيا نادر، وشريك يبني تموضع الأراضي بصبر أندر. هذا الفريق كذلك بالضبط.",
      ru: "Долгосрочное мышление о Турции редкость — партнёр, терпеливо выстраивающий размещение земель, ещё реже. Это ровно эта команда.",
    },
    author: "A. Yılmaz",
    role: { tr: "Kurumsal Yatırımcı, İstanbul", en: "Institutional Investor, Istanbul", ar: "مستثمر مؤسسي، إسطنبول", ru: "Институциональный инвестор, Стамбул" },
  },
  {
    id: "t3",
    quote: {
      tr: "Ege villa projesindeki detay disiplini, Anadolu'da az rastlanan bir standardı sahaya taşıyor.",
      en: "The detail discipline on the Aegean villas brings a standard to Anatolia that is rarely met on site.",
      ar: "انضباط التفاصيل في فلل إيجه ينقل إلى الأناضول معياراً نادر التحقق في الموقع.",
      ru: "Дисциплина деталей на эгейских виллах приносит в Анатолию стандарт, редко встречающийся на площадке.",
    },
    author: "L. Moreau",
    role: { tr: "Mimar, Cenevre", en: "Architect, Geneva", ar: "معماري، جنيف", ru: "Архитектор, Женева" },
  },
];

export const INSIGHTS = [
  {
    id: "i1",
    tag: { tr: "Saha Notu", en: "Field Note", ar: "ملاحظة ميدانية", ru: "Полевая заметка" },
    date: "Şubat / February 2026",
    title: {
      tr: "İstanbul'un yeni iş coğrafyası: Şişli–Levent hattı ve sonrası",
      en: "Istanbul's new business geography: the Şişli–Levent line and beyond",
      ar: "الجغرافيا التجارية الجديدة لإسطنبول: خط شيشلي–ليفنت وما بعده",
      ru: "Новая деловая география Стамбула: линия Шишли–Левент и дальше",
    },
    image: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=1400&q=80",
  },
  {
    id: "i2",
    tag: { tr: "Arazi Notu", en: "Land Note", ar: "ملاحظة أرض", ru: "Земельная заметка" },
    date: "Ocak / January 2026",
    title: {
      tr: "Marmara–Ege koridoru: bir yatırım tezini toprakla yazmak",
      en: "The Marmara–Aegean corridor: writing an investment thesis with land",
      ar: "ممر مرمرة–إيجه: كتابة أطروحة استثمارية بالأرض",
      ru: "Мраморно-Эгейский коридор: инвестиционный тезис, написанный землёй",
    },
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1400&q=80",
  },
  {
    id: "i3",
    tag: { tr: "Mimari", en: "Architecture", ar: "عمارة", ru: "Архитектура" },
    date: "Aralık / December 2025",
    title: {
      tr: "Ege sahilinde bir villayı ölçmek: malzeme, ışık, manzara",
      en: "Measuring a villa on the Aegean: material, light, view",
      ar: "قياس فيلا على بحر إيجه: المواد، الضوء، الإطلالة",
      ru: "Как измерить виллу на Эгейском море: материал, свет, вид",
    },
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
  },
];

export const FAQ = [
  {
    id: "q1",
    q: {
      tr: "TA Clé Invest tam olarak neye yatırım yapar?",
      en: "What exactly does TA Clé Invest invest in?",
      ar: "بماذا يستثمر TA Clé Invest بالضبط؟",
      ru: "Во что именно инвестирует TA Clé Invest?",
    },
    a: {
      tr: "Marmara ve Ege koridorlarında ticari ve endüstriyel araziler, İstanbul'da prime ticari mülkler, seçilmiş konut varlıkları ve Güney Ege'de imza villa geliştirme projeleri.",
      en: "Commercial and industrial land across the Marmara and Aegean corridors, prime commercial property in Istanbul, selected residential holdings and signature villa development on the South Aegean.",
      ar: "أراضٍ تجارية وصناعية على ممرَي مرمرة وإيجه، عقارات تجارية راقية في إسطنبول، عقارات سكنية مختارة، وتطوير فلل مميزة على بحر إيجه الجنوبي.",
      ru: "Коммерческие и промышленные земли на Мраморном и Эгейском коридорах, премиальная коммерческая недвижимость в Стамбуле, отобранные жилые объекты и авторская линия вилл на южном Эгее.",
    },
  },
  {
    id: "q2",
    q: {
      tr: "Bir gayrimenkul fonu musunuz?",
      en: "Are you a real-estate fund?",
      ar: "هل أنتم صندوق عقاري؟",
      ru: "Вы фонд недвижимости?",
    },
    a: {
      tr: "Hayır. Bir anonim şirketin bilançosunu yönetiyoruz. Fon vadesi yok; sermayemiz yapısı gereği kalıcı, kararlarımız da öyle.",
      en: "No. We manage the balance sheet of a joint-stock company. There is no fund horizon; our capital is permanent by structure, and so is our decision-making.",
      ar: "لا. ندير الميزانية العمومية لشركة مساهمة. لا أفق زمني للصندوق؛ رأس مالنا دائم بطبيعته، وكذلك قراراتنا.",
      ru: "Нет. Мы управляем балансом акционерного общества. Срока фонда нет; наш капитал постоянен по структуре, как и наши решения.",
    },
  },
  {
    id: "q3",
    q: {
      tr: "Yabancı yatırımcılarla çalışıyor musunuz?",
      en: "Do you work with foreign investors?",
      ar: "هل تعملون مع مستثمرين أجانب؟",
      ru: "Работаете ли вы с иностранными инвесторами?",
    },
    a: {
      tr: "Evet. Kurumsal yönetim yapımız ve uluslararası bağlantılarımız, seçilmiş yabancı yatırımcılarla ölçülü ortaklıklar kurmamıza olanak tanır. Türkiye'de gayrimenkul edinimi için gerekli hukuki yolu birlikte yürüyoruz.",
      en: "Yes. Our governance structure and international relationships allow measured partnerships with select foreign investors. We walk the legal path of Turkish real estate acquisition alongside you.",
      ar: "نعم. تتيح لنا بنيتنا الحوكمية وعلاقاتنا الدولية إقامة شراكات مدروسة مع مستثمرين أجانب مختارين. نسير معكم في المسار القانوني لاقتناء العقار التركي.",
      ru: "Да. Наша структура управления и международные связи позволяют выборочные партнёрства с иностранными инвесторами. Мы вместе проходим юридический путь приобретения недвижимости в Турции.",
    },
  },
  {
    id: "q4",
    q: {
      tr: "Villa projesi hakkında bilgi alabilir miyim?",
      en: "Can I enquire about the villa project?",
      ar: "هل يمكنني الاستفسار عن مشروع الفلل؟",
      ru: "Можно ли узнать о проекте вилл?",
    },
    a: {
      tr: "Elbette. Ege villa hattımız sınırlı sayıda özel alıcıya sunulmaktadır. Aşağıdaki formdan doğrudan yazın; her mesaj kişisel olarak yanıtlanır.",
      en: "Of course. Our Aegean villa line is offered to a limited number of private buyers. Write to us directly via the form below — every message is answered personally.",
      ar: "بالتأكيد. تُعرض فلل إيجه لعدد محدود من المشترين الخاصين. اكتب لنا مباشرة عبر النموذج أدناه.",
      ru: "Конечно. Наша эгейская линия вилл предлагается ограниченному числу частных покупателей. Напишите нам напрямую через форму ниже.",
    },
  },
  {
    id: "q5",
    q: {
      tr: "Merkeziniz nerede?",
      en: "Where are you based?",
      ar: "أين مقركم؟",
      ru: "Где вы находитесь?",
    },
    a: {
      tr: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 İstanbul.",
      en: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 Istanbul.",
      ar: "شارع بويوكديري 175/6، فيركو سيغنتشر، إسنتيبي، شيشلي 34394 إسطنبول.",
      ru: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Шишли 34394, Стамбул.",
    },
  },
];

export const CONTACT_INFO = {
  email: "hello@tacleinvest.com",
  phones: [
    { label: "T", number: "+90 850 302 40 60" },
    { label: "M", number: "+90 532 284 42 83" },
  ],
  address: "Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 İstanbul, Türkiye",
};

// Official logo asset provided by the client
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dee5502b-4cf4-45e5-b15f-baf51fa7923f/artifacts/95epo7im_TACLE%20Logo%20PNG.png";
